<template>




<!-- 	<el-button class="button elBtn" 
	
	:type="isPrimed?'default':((sText==='Offline'||sText==='Disabled'||sText==='stopping')?'default':'success')">
		
		</el-button> -->
		<!-- :class="[scene.name === currentScene ? 'button-active' : '']" -->
		<div
		class="button buttonwap"
		:class="[isPrimed?'button-muted':((sText==='Offline'||sText==='Disabled'||sText==='stopping')?'':'button-success')]"
		
		@click="buttonClick">
			
			<div>
				<span v-if="isPrimed">
					再次点击以确定
					<strong v-if="cooldown&&false">(等候一秒)</strong>
				</span>
				
				<slot v-else />
			</div>
		</div>
		
</template>

<script>
	export default {
		props: {
			vibrate: Boolean,
			sText:{
				type:[String,Array],
				default:'',
			}
		},
		data() {
			return {
				cooldown: false,
				isPrimed: false,
				buttonType:'',
			}
		},
		methods: {
			buttonClick() {
				if (this.cooldown) {
					return
				}

				if (this.isPrimed) {
					this.isPrimed = false
					this.$emit('click')
					clearTimeout(this._timeout)
					return
				}

				this.isPrimed = true
				this.cooldown = true
				this._timeout = setTimeout(() => {
					this.cooldown = false
					this._timeout = setTimeout(() => {
						this.isPrimed = false
						this._timeout = null
					}, 5000)
				}, 1)

				if (this.vibrate && window.navigator.vibrate) {
					window.navigator.vibrate(200)
				}
			}
		}
	}
</script>

<style type="text/css">
	.elBtn{
		border-color: #DCDFE6!important;
	}
</style>
